import React from 'react';
import {useAppSelector} from "../../../../../../../common/hook";
import {getCabinetData} from "../../../../../../../entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {SERVICE_ACTS} from "../../../../../../../entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {ActsCartsLink} from "./acts-carts-link/ActsCartsLink";

export const ActsCart = () => {
    const cabinetData = useAppSelector(getCabinetData);

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{SERVICE_ACTS}</p>
                </div>
                {cabinetData?.servicesRendered && (
                    <span className="sub-data">{cabinetData?.servicesRendered.count}</span>
                )}
            </div>
            {cabinetData?.servicesRendered?.items && cabinetData?.servicesRendered.items.length > 0 ? (
                <div className="info-card-content">
                    {cabinetData?.servicesRendered.items.map((act, index) => (
                        <div className="row auto-height" key={index}>
                            <div className="file-time-grid">
                                <div className="col">
                                    <p className="file no-wrap">
                                        <a href={act.link}>{act.title}</a>
                                    </p>
                                </div>
                                <div className="col time-col">
                                    <time className="time">
                                        {act.date}, {act.time}
                                    </time>
                                </div>
                            </div>
                        </div>
                    ))}

                    <ActsCartsLink/>

                </div>
            ) : (
                <div className="info-card-content">
                <NothingYetMessage />
                </div>
            )}
        </div>
    );
};
